/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ParameterUpdate interface.
 */
export function instanceOfParameterUpdate(value) {
    if (!('allowOwnCredentialManagement' in value) || value['allowOwnCredentialManagement'] === undefined)
        return false;
    return true;
}
export function ParameterUpdateFromJSON(json) {
    return ParameterUpdateFromJSONTyped(json, false);
}
export function ParameterUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'allowOwnCredentialManagement': json['allow_own_credential_management'],
        'rateLimitBytesPerSecond': json['rate_limit_bytes_per_second'] == null ? undefined : json['rate_limit_bytes_per_second'],
        'sshClientAuthPublickey': json['ssh_client_auth_publickey'] == null ? undefined : json['ssh_client_auth_publickey'],
        'sshClientAuthPassword': json['ssh_client_auth_password'] == null ? undefined : json['ssh_client_auth_password'],
        'sshClientAuthKeyboardInteractive': json['ssh_client_auth_keyboard_interactive'] == null ? undefined : json['ssh_client_auth_keyboard_interactive'],
        'minimizePasswordLogin': json['minimize_password_login'] == null ? undefined : json['minimize_password_login'],
        'showSessionMenu': json['show_session_menu'] == null ? undefined : json['show_session_menu'],
    };
}
export function ParameterUpdateToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'allow_own_credential_management': value['allowOwnCredentialManagement'],
        'rate_limit_bytes_per_second': value['rateLimitBytesPerSecond'],
        'ssh_client_auth_publickey': value['sshClientAuthPublickey'],
        'ssh_client_auth_password': value['sshClientAuthPassword'],
        'ssh_client_auth_keyboard_interactive': value['sshClientAuthKeyboardInteractive'],
        'minimize_password_login': value['minimizePasswordLogin'],
        'show_session_menu': value['showSessionMenu'],
    };
}
